/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceConfigurationModel } from '../../models/service-configuration-model';

export interface AnonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params {
  healthCareServiceFhirId: string;
  locationFhirId: string;
  specialityFhirId: string;
}

export function anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(http: HttpClient, rootUrl: string, params: AnonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceConfigurationModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('healthCareServiceFhirId', params.healthCareServiceFhirId, {});
    rb.path('locationFhirId', params.locationFhirId, {});
    rb.path('specialityFhirId', params.specialityFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<ServiceConfigurationModel>;
    })
  );
}

anonymousServiceConfigurationHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH = '/Anonymous/ServiceConfigurationHoursOfOperation/{healthCareServiceFhirId}/{locationFhirId}/{specialityFhirId}';
